<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="character">
      <div class="character__bg">
        <div class="character__bg-view"></div>
      </div>
      <FrameBook></FrameBook>
      <div class="character__contents">
        <div class="character__txt">
          <div class="character__txt-bg"></div>
          <div class="character__txt-bl">
            <span class="bl--1"></span><span class="bl--2"></span
            ><span class="bl--3"></span>
            <hr class="bl--r" />
            <hr class="bl--l" />
          </div>
          <div class="character__txt-tit" v-html="$t('character.tit')"></div>
          <div class="character__txt-desc" v-html="$t('character.desc')"></div>
          <a :href="notice.link" class="character__txt-desc note" v-html="$t('character.note')"></a>
          <div class="character__btn-con">
            <a
              href="/preorder/character/210930/index/"
              class="character__btn character__btn--class"
              target="blank"
              >{{ $t("menu.character") }}</a
            >
            
          </div>
        </div>
      </div>
      <ScrollBtn></ScrollBtn>
      <PreorderBtn></PreorderBtn>
    </section>
  </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";
import PreorderBtn from "../components/PreorderBtn";
import promokit from "@/utils/promokit";

export default {
  name: "character",
  components: { FrameBook, ScrollBtn, PreorderBtn },
  mixins: [BaseSection],
  data() {
    return {
      name: "character",
      bg: null,
      //indexLoopVideo: null,
      //indexLeaveVideo: null,
      titMotion: null,
      introSpeed: 1,
      thumbPlayer: "",
      youtube: {
        ko: "7rftoidCYqo",
        en: "NI-StVML2Pk",
        ja: "DLRs5eL-TQw",
        zh: "rrytkGu268k",
      },
      device: promokit.util.getDevice(),
    };
  },
  computed: {
    ...mapState(["contentsData", "country", "lang"]),
    notice() {
      const notice = {
        link:
          "/" +
          this.country.toLowerCase() +
          "/" +
          this.contentsData.notice.link,
        title: this.contentsData.notice.title,
      };
      return notice;
    }
  },
  methods: {
    note(){
      if(this.lang === 'ko'){
        alert('11시부터 참여 가능합니다')
      }else if(this.lang === 'en'){
        alert('Available from 11AM')
      }else if(this.lang === 'ja'){
        alert('11時から参加可能です')
      }else if(this.lang === 'zh'){
        alert('活動將於11點（KST）開始')
      }
    },
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0,  ease: "power2.easeOut" });

      this.titMotion = new gsap.timeline({ paused: true });
      this.titMotion
        /*
        .addLabel("start")
        .from(this.$el.querySelector(`.${this.name}__logo`), 0.5, {
          scale: 1.2,
          autoAlpha: 0,
          ease: "power4.easeOut",
        })
        .addLabel("title")
        .fromTo(
          this.$el.querySelector(`.${this.name}__logo > div`),
          1,
          { autoAlpha: 1 },
          { autoAlpha: 0, ease: "expo.easeInOut" },
          "title"
        )*/
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--1`),
          0.4,
          { autoAlpha: 0, rotation: 190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--2`),
          0.4,
          { autoAlpha: 0, rotation: -190 },
          { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--3`),
          0.4,
          { autoAlpha: 0, scale: 3 },
          { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
          "title"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--r`),
          0.4,
          { autoAlpha: 0, x: -30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt .bl--l`),
          0.4,
          { autoAlpha: 0, x: 30, y: -5 },
          { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-bg`),
          0.4,
          { autoAlpha: 0, y: -10 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.2"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-tit`),
          0.4,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.4"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 0.6, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__txt-desc.note`),
          0.4,
          { autoAlpha: 0, y: -30 },
          { autoAlpha: 0.3, y: 0, ease: "expo.easeOut" },
          "title+=0.6"
        )
        .fromTo(
          this.$el.querySelector(`.${this.name}__btn-con`),
          0.5,
          { autoAlpha: 0 },
          { autoAlpha: 1, ease: "expo.easeOut" },
          "title+=0.8"
        )
        .fromTo(
          this.$el.querySelector(`.scroll-btn`),
          0.5,
          { autoAlpha: 0, y: 30 },
          { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
          "title+=0.9"
        );
    },
    enter(el, done) {
      this.setMotion();
      this.enterMotion.eventCallback("onComplete", () => {
        done();
        this.setIsMovePage(false);
      });
      //if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);



    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
    },
    start() {
      this.enterMotion.play();
      this.titMotion.play();
    },
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
    //this.indexLoopVideo = document.querySelector("#classLoopVideo");
    //this.indexLoopVideo.play();
  },
};
</script>

<style lang="scss">
.character {
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    // opacity: 0;
    // display: none;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      @include bg($bg: "../assets/img/character_bg_pc.jpg");
      background-size: cover;
      &::after {
        display: block;
        content: "";
        width: 100%;
        height: 100%;
        background-color: rgba($color: black, $alpha: 0.1);
        position: absolute;
        left: 0;
        top: 0;
      }
      video {
        min-width: 100% !important;
        min-height: 100% !important;
        width: auto;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        &#indexLeaveVideo {
          display: none;
        }
      }
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 100%;
    //  background: #f0f;
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 50%,
      $left: 50%
    );
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
    }
    margin-top: -416px;
    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 684px,
        $height: 86px,
        $top: 220px,
        $left: 50%
      );
      margin-left: -342px;
      @include bg($bg: "../assets/img/ko/character_tit_ko.png", $cover: cover);
      @include hide-text;
      .en & {
        width: 1013px;
        height: 88px;
        margin-left: -506px;
        @include bg($bg: "../assets/img/en/character_tit_en.png", $cover: cover);
      }
      .ja & {
        width: 908px;
        height: 84px;
        margin-left: -454px;
        @include bg($bg: "../assets/img/ja/character_tit_ja.png", $cover: cover);
      }
      .zh & {
        width: 516px;
        height: 83px;
        margin-left: -258px;
        @include bg($bg: "../assets/img/zh/character_tit_zh.png", $cover: cover);
      }
    }
    &-hr {
      border: none;
      @include position(
        $position: absolute,
        $width: 467px,
        $height: 37px,
        $top: 431px,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_line.png");
      .en &,
      .zh &,
      .ja & {
        top: 386px;
      }
    }
    &-desc {
      &.note{
        top:370px !important;
        font-size: 16px;
        color: #fffbe4;
        opacity: 0.3;
      }
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 332px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.6;
      &::before {
        display: inline-block;
        content: "";
        @include position(
          $position: absolute,
          $width: 583px,
          $height: 212px,
          $top: -83px,
          $left: 50%
        );
        background: url("../assets/img/sub_bg_long.png");
        background-size: contain;
        z-index: -1;
        .ja &,
        .zh & {
          background: url("../assets/img/sub_bg_short.png");
        }
      }
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
    }
  }
  &__notice {
    @include position(
      $position: absolute,
      $width: 100%,
      $top: 462px,
      $left: 50%
    );
    text-align: center;
    font-size: 15px;
    color: #bdb6a6;
    &:hover {
      text-decoration: underline;
      color: #bdb6a6;
    }
    &:before {
      vertical-align: middle;
      display: inline-block;
      width: 24px * 0.65;
      height: 30px * 0.65;
      margin-right: 10px;
      @include bg($bg: "../assets/img/icon_notice.png", $cover: cover);
      content: "";
    }
    .en &,
    .ja &,
    .zh & {
      top: 416px;
    }
  }
  &__btn-con {
    @include position(
      $position: absolute,
      $width: 100%,
      $top: 508px,
      $left: 50%
    );
    text-align: center;
  }
  &__btn {
    @include position($position: relative, $width: 338px, $height: 100px);
    @include hide-text;
    display: inline-block;
    margin: 0;
    background-size: 338px auto;
    .en &{
      width: 398px;
      background-size: 398px auto;
    }
    .ja &{
      width: 398px;
      background-size: 398px auto;
    }
    &:after {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 0
      );
      content: "";
      background-size: 338px auto;
      opacity: 0;
      transition: 0.3s;
      background-position-y: -95px !important;
      .en &{
        background-size: 398px auto;
        background-position-y: -94px !important;
      }
      .ja &{
        background-size: 398px auto;
      }
    }

    &:hover {
      &:after {
        opacity: 1;
        transition: 0.3s;
      }
    }
    &--class {
      & {
        @include bg($bg: "../assets/img/ko/character_btn_detail_ko.png");
        &:after {
          @include bg($bg: "../assets/img/ko/character_btn_detail_ko.png");
        }
      }
      .en & {
        @include bg($bg: "../assets/img/en/character_btn_detail_en.png");
        &:after {
          @include bg($bg: "../assets/img/en/character_btn_detail_en.png");
        }
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/character_btn_detail_ja.png");
        &:after {
          @include bg($bg: "../assets/img/ja/character_btn_detail_ja.png");
        }
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/character_btn_detail_zh.png");
        &:after {
          @include bg($bg: "../assets/img/zh/character_btn_detail_zh.png");
        }
      }
    }
    &--showcase {
      .ko & {
        @include bg($bg: "../assets/img/ko/index_btn_showcase.png");
      }
      &:after {
        @include bg($bg: "../assets/img/ko/index_btn_showcase.png");
        background-position-y: -140px;
      }
      .en & {
        @include position(
          $position: relative,
          $width: 291px * 0.78,
          $height: 93px * 0.78
        );
        background-size: 291px * 0.78 auto;
        @include bg($bg: "../assets/img/en/index_btn_showcase_en.png");
        &:after {
          background-size: 291px * 0.78 auto;
          @include bg($bg: "../assets/img/en/index_btn_showcase_en.png");
        }
      }
      .ja & {
        @include bg($bg: "../assets/img/ja/index_btn_showcase_ja.png");
        &:after {
          @include bg($bg: "../assets/img/ja/index_btn_showcase_ja.png");
          background-position-y: -140px;
        }
      }
      .zh & {
        @include bg($bg: "../assets/img/zh/index_btn_showcase_zh.png");
        &:after {
          @include bg($bg: "../assets/img/zh/index_btn_showcase_zh.png");
          background-position-y: -140px;
        }
      }
    }
  }
  &__movie-con {
    @include position(
      $position: absolute,
      $width: 426px,
      $height: 240px,
      $bottom: 0,
      $right: 0
    );
    z-index: 10;
    .promokit-youtube,
    .promokit-youtube__screen-wrap {
      width: 426px;
      height: 240px;
    }
    .promokit-youtube__bg {
      display: none;
    }
  }
  &__movie-mobile-layer {
    pointer-events: all;
    @include position(
      $position: absolute,
      $width: 100%,
      $height: auto,
      $top: 0px,
      $right: 0px,
      $bottom: 0px,
      $left: 0px
    );
    z-index: 10;
  }
  &__movie-close {
    @include position(
      $position: absolute,
      $width: 48px,
      $height: 48px,
      $top: 4px,
      $right: 4px
    );
    @include bg($bg: "../assets/img/icon_video_x.png", $cover: cover);
    z-index: 11;
  }
  &__movie-layer {
    pointer-events: all;
    @include position(
      $position: absolute,
      $width: 48px,
      $height: 48px,
      $top: 5px,
      $right: 48px
    );
    @include bg($bg: "../assets/img/icon_video_y.png", $cover: cover);
    z-index: 11;
  }

  @include bp(tablet) {
    &__bg {
      min-height: auto;
      &-view {
        video {
          height: 100%;
        }
        @include bg($bg: "../assets/img/character_bg_m.jpg");
      }
    }
    &__logo {
      @include position(
        $position: absolute,
        $width: 820px * 0.42,
        $height: 270px * 0.42,
        $top: 40px,
        $left: 50%
      );
      margin-top: 0;
    }
    &__txt {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 563px/2,
        $top: 50%,
        $left: 50%
      );
      margin-top: -230px;

      &-bg {
        display: none;
        /*
        @include position(
          $position: absolute,
          $width: 100%,
          $height: 100%,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
        background-size: 360px auto;
        */
      }

      &-bl {
        display: none;
        /*
        top: 47px;
        transform: scale(0.5);
        */
      }
      &-tit {
        width: 289px;
        height: 132px;
        @include position(
          $position: absolute,
          $top: 10px,
          $left: 50%
        );
        margin-left: -144px;
        transform: initial;
        @include bg(
          $bg: "../assets/img/ko/character_tit_ko_m.png",
          $cover: cover
        );
        
        .en & {
          width: 332px;
          height: 127px;
          margin-left: -166px;
          transform: initial;
          @include bg(
            $bg: "../assets/img/en/character_tit_en_m.png",
            $cover: cover
          );
        }
        .ja & {
          width: 332px;
          height: 128px;
          margin-left: -166px;
          transform: initial;
          @include bg(
            $bg: "../assets/img/ja/character_tit_ja_m.png",
            $cover: cover
          );
        }
        .zh & {
          width: 314px;
          height: 92px;
          margin-left: -157px;
          transform: initial;
          top: 50px !important;
          @include bg(
            $bg: "../assets/img/zh/character_tit_zh_m.png",
            $cover: cover
          );
        }
      }
      &-hr {
        @include position(
          $position: absolute,
          $width: 200px,
          $height: 20px,
          $top: 185px,
          $left: 50%
        );
        background-size: cover;
        .en & {
          top: 215px;
        }
        .ja & {
          top: 185px;
        }
        .zh & {
          top: 163px;
        }
      }
      &-desc {
        &.note{
          font-size: 12px !important;
          top: 150px !important;
          opacity: 0.3 !important;
          .en &{
            letter-spacing: 0px !important;
          }
          .en & {
            top: 180px !important;
          }
          .zh & {
            top: 180px !important;
          }
        }
        top: 130px;
        font-size: 13px;
        text-align: center;
        letter-spacing: -0.5px;
        line-height: 1.8em;
        opacity: 0.6 !important;
        &::before {
          @include position(
            $position: absolute,
            $width: 100%,
            $height: 100%,
            $top: 0,
            $left: 50%
          );
          @include bg($bg: "../assets/img/sub_bg_long.png", $position: 50% 0);
          background-size: 360px auto;
        }
        .en & {
            //top: 180px !important;
            letter-spacing: -0.9px !important;
          }
      }
    }
    &__notice {
      top: 200px;
      font-size: 12px;
      &:before {
        width: 24px * 0.5;
        height: 30px * 0.5;
        margin-right: 5px;
      }
      .en & {
        top: 230px;
      }
      .ja & {
        top: 201px;
      }
      .zh & {
        top: 179px;
      }
    }
    &__btn-con {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 180px,
        $left: 50%
      );
      text-align: center;
      .en & {
        top: 210px;
      }
      .zh & {
        top: 210px;
      }
      
    }
    &__btn {
      @include position(
        $position: relative,
        $width: 466px * 0.5,
        $height: 226px * 0.5
      );
      background: url(../assets/img/ko/character_btn_detail_ko_m.png);
      background-size: 466px * 0.5 auto;
      &:after {
        display: none;
      }
      .en & {
        width: 273px;
        background: url(../assets/img/en/character_btn_detail_en_m.png);
        background-size: 546px * 0.5 auto;
      }
      .ja & {
        width: 273px;
        background: url(../assets/img/ja/character_btn_detail_ja_m.png);
        background-size: 546px * 0.5 auto;
      }
      .zh & {
        background: url(../assets/img/zh/character_btn_detail_zh_m.png);
        background-size: 466px * 0.5 auto;
      }
    }
    &__movie-con {
      @include position(
        $position: absolute,
        $width: 156px,
        $height: 88px,
        $bottom: 0,
        $right: 0
      );
      .promokit-youtube,
      .promokit-youtube__screen-wrap {
        width: 156px;
        height: 88px;
      }
    }
    &__movie-close {
      @include position(
        $position: absolute,
        $width: 30px,
        $height: 30px,
        $top: 4px,
        $right: 4px
      );
    }
    &__movie-layer {
      display: none;
    }
  }
  @include bp(mobile) {
    &__movie-con {
      .promokit-youtube {
        min-width: auto;
        width: 156px;
        height: 88px;
      }
    }
  }
  @media (max-width: 960px) and (min-aspect-ratio: 1920/1080) {
    &__bg {
      &-view {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
